import { useEffect } from "react";
import { useDispatch } from "react-redux";
import queryString from "query-string";
import { useLocation, useNavigate } from "react-router-dom";
import { updateLoader } from "../../redux/action/loaderAction";
import { teamsFetch } from "../../redux/action/teamActions";
import ReportForm from "./billingReportForm";
import { useCreateBillingReportMutation } from "../../app/services/lily";
import { Spin } from "antd";
import moment from "moment";
import React from "react";

export const RiderBillingReport = ({ openNotificationWithIcon }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { clientId, authToken } = queryString.parse(location.search);

  const onSubmit = (values) => {
    const payload = {
      startDate: moment(values.date).format("YYYY-MM-DD"),
      endDate: moment(values.date).format("YYYY-MM-DD"),
      teamIds: values.storeIds,
      tranporterType: "ALL",
    };
    createBillingReport({ clientId, authToken, reqBody: payload });
  };

  const [
    createBillingReport,
    {
      isLoading: isCreating,
      data: createBillingReportData,
      error: createBillingReportError,
      isError: iscreateBillingReportError,
      isSuccess: iscreateBillingReportSuccess,
    },
  ] = useCreateBillingReportMutation();

  useEffect(
    () => {
      dispatch(teamsFetch({ clientId, authToken }, navigate, handleError));
    }, //eslint-disable-next-line
    [authToken, clientId, dispatch]
  );

  useEffect(
    () => {
      if (iscreateBillingReportSuccess) {
        openNotificationWithIcon(
          "success",
          "Report triggered to your mail.",
          JSON.stringify(
            createBillingReportData?.message || "Report procced Successfully"
          )
        );
      }
    }, //eslint-disable-next-line
    [iscreateBillingReportSuccess]
  );

  useEffect(
    () => {
      if (!iscreateBillingReportError) return;

      if (createBillingReportError?.status === 401) navigate("/unauthorized");
      handleError([
        createBillingReportError?.data?.data?.message ||
          createBillingReportError?.data?.message,
      ]);
    }, //eslint-disable-next-line
    [iscreateBillingReportError, createBillingReportError, navigate, location]
  );

  const handleError = (error) => {
    dispatch(updateLoader({ reconLoading: false }));
    openNotificationWithIcon(
      "error",
      "Something went wrong",
      JSON.stringify(
        error?.message || error?.errorResponse?.errorMessage || error
      )
    );
  };

  return (
    <>
      {isCreating ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <Spin size="large" />
        </div>
      ) : (
        <ReportForm
          openNotificationWithIcon={openNotificationWithIcon}
          onSubmit={onSubmit}
        />
      )}
    </>
  );
};
